import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import Footer from '../../Commons/Components/Footer';
import Header from '../../Commons/Components/Header';
import { FormattedMessage } from 'react-intl';
import Container from './Container';
import DropdownLeftIcon from '../../Assets/Images/icon-dropdown-left.png';

const Payment = (props) => {
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const onClickHistoryBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <>
      {!isMobile ? (
        <Header />
      ) : (
        <div className="mobile_header">
          <img src={DropdownLeftIcon} alt="go_back" onClick={onClickHistoryBack} />
          <FormattedMessage id={'PAYMENT'} />
        </div>
      )}
      <Container {...props} />
      <Footer />
    </>
  );
};

export default Payment;
